'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _select = require('@alicd/next/lib/select');

var _select2 = _interopRequireDefault(_select);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SelectInner = _select2.default.prototype.render.call({
    _getInstance: function _getInstance() {},
    props: {} }).type;

exports.default = SelectInner;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./node_modules/_@alicd_crui-select-field@0.0.22@@alicd/crui-select-field/lib/SelectInner.js
// module id = 667
// module chunks = 0